import { StyleSheet } from 'react-native-unistyles';

import { theme } from '@squire/ui';

export const styles = StyleSheet.create((colors) => ({
  row: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: theme.spacing[4],
    paddingVertical: theme.spacing[4],
    paddingHorizontal: theme.spacing[4],
    borderRadius: theme.borderRadius.s,
    borderWidth: 1,
    borderColor: colors.borderPrimary,
    backgroundColor: 'transparent',
  },

  rowHighlighted: {
    backgroundColor: colors.backgroundBrandSubtle,
    borderColor: colors.borderBrand,
  },

  iconTile: {
    width: 40,
    height: 40,
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: theme.borderRadius.s,
    backgroundColor: colors.backgroundL1Alpha,
  },

  text: {
    flex: 1,
  },

  name: {
    color: colors.textPrimary,
  },

  count: {
    color: colors.textSecondary,
  },
}));
